import { PAGE_PATH } from '@shopgate/pwa-common/constants/RoutePaths';

export const QUICKLINKS_MENU = 'quicklinks';
export const IMPRINT_PATH = `${PAGE_PATH}/imprint`;
export const PAYMENT_PATH = `${PAGE_PATH}/payment`;
export const PRIVACY_PATH = `${PAGE_PATH}/privacy`;
export const RETURN_POLICY_PATH = `${PAGE_PATH}/return_policy`;
export const SHIPPING_PATH = `${PAGE_PATH}/shipping`;
export const TERMS_PATH = `${PAGE_PATH}/terms`;
